import * as styles from "./YearPickerContent.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";
import { pointerAlignOffset } from "@frontend/utils/pointerAlign";

import { useYearPickerContext } from "./YearPicker.context";
import type { YearPickerContentProps } from "./YearPicker.types";
import { YearPickerArrow } from "./YearPickerArrow";
import { YearPickerBackdrop } from "./YearPickerBackdrop";
import { YearPickerGrid } from "./YearPickerGrid";
import { YearPickerHeader } from "./YearPickerHeader";
import { YearPickerPortal } from "./YearPickerPortal";
import { ARROW_SIZES } from "./constants";

const GAP = 4;

export function YearPickerContent({
  className,
  side = "bottom",
  sideOffset,
  align = "center",
  alignOffset,
  positionMethod,
  ...props
}: YearPickerContentProps): JSX.Element {
  const { arrow, size, pointerOffsetRef } = useYearPickerContext();

  return (
    <YearPickerPortal>
      <YearPickerBackdrop />
      <BasePopover.Positioner
        data-slot="year-picker-positioner"
        side={side}
        sideOffset={sideOffset ?? (arrow ? ARROW_SIZES[size] : GAP)}
        align={align}
        alignOffset={alignOffset ?? pointerAlignOffset(pointerOffsetRef, arrow)}
        positionMethod={positionMethod}
        className={styles.positioner}
      >
        <BasePopover.Popup
          data-slot="year-picker-popup"
          className={clsx(styles.popup, className)}
          {...props}
        >
          {arrow && <YearPickerArrow />}
          <YearPickerHeader />
          <YearPickerGrid />
        </BasePopover.Popup>
      </BasePopover.Positioner>
    </YearPickerPortal>
  );
}
